module.exports = __webpack_public_path__ + "img/thumbnail_GiantPanda_f_albino.5d748c8b.png";